import React from 'react';

const AdminLogo: React.FC<{ size?: number }> = ({ size = 32 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="zogzilaGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#086afb" />
          <stop offset="100%" stopColor="#e7038e" />
        </linearGradient>
      </defs>
      {/* Z shape: top bar, diagonal, bottom bar */}
      <polygon
        points="15,15 85,15 85,30 38,70 85,70 85,85 15,85 15,70 62,30 15,30"
        fill="url(#zogzilaGrad)"
      />
    </svg>
  );
};

export default AdminLogo;

